import EnumParams from './params';

enum EnumSimPage {
  active = 'active',
  predeployment = 'predeployment',
  deactivated = 'deactivated',
  details = 'details',
  profiles = 'profiles',
  recentSessions = 'recentsessions',
  simAndDevices = 'simanddevices',
  usage = 'usage',
  coverage = 'coverage',
  pricing = 'pricing',
  tags = 'tags',
  activity = 'activity',
  activityHistoryDetails = `activity/:${EnumParams.batchJobId}/details`,
}

export default EnumSimPage;
